import { useShallowEqualSelector } from 'hooks';

const selector = state => state?.contributions?.activeContribution || {};

function useContribution() {
  return useShallowEqualSelector(selector);
}

export default useContribution;
